import React from 'react';
import { cn } from "@/lib/utils";

export interface ProfileInfoProps {
  fullName: string;
  userRole: string;
  joinDate: string;
  email?: string;
}

const ProfileInfo = ({ fullName, userRole, joinDate, email }: ProfileInfoProps) => {
  // Format name to show first name and last initial
  const formatName = (name: string) => {
    const nameParts = name.split(' ');
    if (nameParts.length < 2) return name;
    
    const firstName = nameParts[0];
    const lastInitial = nameParts[nameParts.length - 1][0] + '.';
    
    return `${firstName} ${lastInitial}`;
  };
  
  const displayName = formatName(fullName);
  return (
    <div className="w-full space-y-6">
      {/* Name - centered to match profile picture */}
      <div className="text-center space-y-1">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white">{displayName}</h3>
      </div>
      
      {/* Info Cards - centered and balanced */}
      <div className="space-y-4">
        {/* Email Card */}
        {email && (
          <div className="bg-gradient-to-r from-blue-50/80 to-indigo-50/80 dark:from-blue-950/30 dark:to-indigo-950/30 rounded-xl p-4 border border-blue-100/50 dark:border-blue-800/30">
            <div className="text-center">
              <div className="text-xs font-medium text-blue-600 dark:text-blue-400 uppercase tracking-wide">Email</div>
              <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 break-all">{email}</div>
            </div>
          </div>
        )}
        
        {/* Member Since Card */}
        <div className="bg-gradient-to-r from-purple-50/80 to-violet-50/80 dark:from-purple-950/30 dark:to-violet-950/30 rounded-xl p-4 border border-purple-100/50 dark:border-purple-800/30">
          <div className="text-center">
            <div className="text-xs font-medium text-purple-600 dark:text-purple-400 uppercase tracking-wide">Member since</div>
            <div className={cn(
              "text-sm font-bold",
              "bg-gradient-to-r from-purple-600 to-violet-600 dark:from-purple-400 dark:to-violet-400 bg-clip-text text-transparent"
            )}>{joinDate}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
